import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { useHasPermissionFn } from '@eastcoal/auth/hooks/useHasPermissionFn'

import { RouterStoreContext } from './contexts/StoreContext'
import { RouterStoreProviderProps } from './interface'
import { createRouterStore } from './store/createStore'

export const RouterStoreProvier = ({
  children,
  /* -------------------------------------------------------------------------- */
  /*                          createRouterStore Options                         */
  /* -------------------------------------------------------------------------- */
  items,
  basename
}: PropsWithChildren<RouterStoreProviderProps>) => {
  const hasPermission = useHasPermissionFn()

  const store = useCreation(
    () => createRouterStore({ items, basename, hasPermission }),
    [items, basename, hasPermission]
  )

  return <RouterStoreContext value={store}>{children}</RouterStoreContext>
}
